import React from 'react'
import "./Megaphone.scss";
const Megaphone = () => {
    return (
        <div className="megaphone">
            <div className="mega"></div>
            <div className="dj"></div>
            <div className="note1"></div>
            <div className="note2"></div>
            <div className="shadow"></div>
        </div>
    )
}

export default Megaphone
